/**
 * Created by jmmartinez on 01/4/19
 * 19/11/2023  Añadido detección de return en Usuario para pasar a Contraseña.
 **/

import React from 'react'
import {connect} from "react-redux";
import {InputGroup, Button, Intent, Icon} from "@blueprintjs/core";
import ClienteRestful from "../framework2/ej2/network/ClienteRestful";
import {servidor, servicioRestfulCompleto, servidorImagenes, servidorNotificaciones} from "./Configuracion"
import './resources/css/login.css';
import {authLogged, authLogouted} from "./redux/auth/actions";
import {crearSession, getSession, cerrarSession} from "../framework2/ej2/utils/SessionUtils";
import {sha256} from "js-sha256";
import {estadoChangePagina, PAGE_USUARIO, PAGE_PRINCIPAL, PAGE_DASHBOARD} from "./redux/estado/actions";
import {setFocus} from "../framework2/ej2/utils/ComponentUtils";
import {authModo} from "./Configuracion";


class Login extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            login: "",
            password: "",
        }
        this.refContraseña= React.createRef();
    }

    componentDidMount() {
        //Entramos a la página sin autenticar pero existe una sesion no caducada.
        //En ese caso hacemos autologin
        let usuarioDatos= getSession();
        if (!this.props.auth.usuario && usuarioDatos) {

            //A veces se satura cuando se mandan varias consultas seguidas
            //Por eso, como esta se lanza al principio y se solapa con otras, le ponemos un retraso de 1 segundo.
            this.timerID = setInterval(
                () => {
                    clearTimeout(this.timerID);
                    this.autologin(usuarioDatos.usuarioCodigo, usuarioDatos.token);
                    },
                1000
            );

        }
    }

    login = () => {
        console.log("LOGIN");
        const {login, password} = this.state;
        console.log("authModo: ", authModo);
        const loginRequest= {
            login: login,
            magicword: authModo == "BDD" ? sha256(password) : password,
            //magicword: password,
            modo: authModo,
        };
        const url= servidor  + "completo/auth/";
        const clienteRestful = new ClienteRestful().setUrl(url);
        console.log("url: ", url);
        console.log("login: ", login);
        console.log("password: ", password);
        console.log("magicword: ", loginRequest.magicword);
        console.log("token: ", loginRequest.token);
        clienteRestful.doPost( loginRequest, response => {
            if (clienteRestful.exito && response){
                console.log("Exito: ", response);
                this.props.dispatch(authLogged(response));
                crearSession(response);
                //this.props.dispatch(estadoChangePagina(PAGE_DASHBOARD));

                //console.log("LOGIN RESPONSE:")
                //console.log(response);
                //console.log("usuarioCodigo: " + response.usuarioCodigo);

            }
        });
        this.setState({login: "", password: ""});

    }

    autologin = (usuarioCodigo, token) => {
        console.log("AUTOLOGIN");
        console.log("usuarioCodigo: ", usuarioCodigo);
        console.log("token: ", token);
        const url= servidor + "completo/auth/autologin/";
        const clienteRestful = new ClienteRestful().setUrl(url);
        let parametros= {
            usuarioCodigo: usuarioCodigo,
            token: token,
            modo: authModo,
        }
        clienteRestful.doPost(parametros, response => {
            console.log(response);
            if (clienteRestful.exito && response){
                this.props.dispatch(authLogged(response));
                crearSession(response);
                //this.props.dispatch(estadoChangePagina(PAGE_DASHBOARD));
            }
            else{
                cerrarSession();
            }
        });


    }


    logout = () => {
        cerrarSession();
        this.props.dispatch(authLogouted());
        this.props.dispatch(estadoChangePagina(PAGE_PRINCIPAL));
    }

    usuarioKeyPress= (data) => {
        if(data.charCode==13){
            setFocus(this.refContraseña);
        }
    }

    passwordKeyPress= (data) =>{
        if(data.charCode==13){
            this.login();
        }
    }

    clickUsuario= () => {
        //this.props.dispatch(estadoChangePagina(PAGE_USUARIO));
    }



    render() {
        const {login, password} = this.state;
        const {auth} = this.props;
        return (
            <>
                {
                    !auth.usuarioCodigo &&
                    <div className="loginContenedor">
                        <div className="loginElemento">
                            <InputGroup
                                id="igUsuario"
                                leftIcon="user"
                                placeholder="Usuario"
                                value={login}
                                onChange={(event) => this.setState({login: event.target.value})}
                                onKeyPress={this.usuarioKeyPress}
                            />
                        </div>
                        <div className="loginElemento">
                            <InputGroup
                                id="igContraseña"
                                inputRef={this.refContraseña}
                                leftIcon="key"
                                placeholder="Contraseña"
                                type={"password"}
                                value={password}
                                onChange={(event) => this.setState({password: event.target.value})}
                                onKeyPress={this.passwordKeyPress}
                            />
                        </div>
                        <div className="loginElemento">
                            <Button onClick={this.login}>ENTRAR</Button>
                        </div>
                    </div>

                }
                {
                    auth.usuarioCodigo &&
                    <div className="loginContenedor">
                        <div className="loginBloqueVertical">
                            <div className="loginNombre" onClick={this.clickUsuario}>
                                <Icon icon="user" iconSize={24} style={{marginRight:10}}/>
                                <span style={{cursor:"pointer", marginRight: 10}}>{auth.usuarioNombre}</span>
                            </div>
                        </div>
                        <Button onClick={this.logout}>SALIR</Button>
                    </div>
                }
            </>
        )
    }
}

Login.propTypes = {}



const mapStateToProps = function(state) {
    return {
        auth: state.auth,
    }
}
export default connect(mapStateToProps)(Login);


